import React from 'react';
export function TxLoadingText(_ref) {
  var children = _ref.children,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? true : _ref$isLoading;
  return React.createElement("span", {
    className: "tx-loading-text"
  }, children, isLoading && React.createElement("span", {
    className: "tx-loading-text__dots"
  }, React.createElement("span", {
    className: "tx-loading-text__dots__dot"
  }, "."), React.createElement("span", {
    className: "tx-loading-text__dots__dot"
  }, "."), React.createElement("span", {
    className: "tx-loading-text__dots__dot"
  }, ".")));
}